import React, { useContext, useRef, useState } from 'react';
import { SweepCanvasRfNode } from '../canvas-types/nodeTypesData';
import { RFEdgeFloatingEdge } from '../edges';
import {
  SetStateActionWithObjectOperation,
  useStateWithGetter,
} from '../helpers/useStateWithGetter';
interface CanvasStateContextType {
  canvasNodes: SweepCanvasRfNode[];
  canvasEdges: RFEdgeFloatingEdge[];
  setCanvasNodes: React.Dispatch<SetStateActionWithObjectOperation<SweepCanvasRfNode>>;
  setCanvasEdges: React.Dispatch<SetStateActionWithObjectOperation<RFEdgeFloatingEdge>>;
  getCanvasNodes: () => SweepCanvasRfNode[];
  getCanvasEdges: () => RFEdgeFloatingEdge[];
  _isCtxInitialized: boolean;
  zoomTransformSuffix: string;
  stateInitialized: React.MutableRefObject<boolean>;
}

const CanvasStateContext = React.createContext<CanvasStateContextType>({
  canvasNodes: [],
  canvasEdges: [],
  setCanvasNodes: () => {},
  setCanvasEdges: () => {},
  getCanvasNodes: () => [],
  getCanvasEdges: () => [],
  _isCtxInitialized: false,
  zoomTransformSuffix: '',
  stateInitialized: { current: false },
});

export const SweepCanvasStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [canvasNodes, setCanvasNodes, getCanvasNodes] = useStateWithGetter<SweepCanvasRfNode>([]);
  const [canvasEdges, setCanvasEdges, getCanvasEdges] = useStateWithGetter<RFEdgeFloatingEdge>([]);

  const [zoomTransformSuffix] = useState(() => Math.random().toString(36).substring(2, 15));
  const stateInitialized = useRef(false);

  return (
    <CanvasStateContext.Provider
      value={{
        canvasNodes,
        canvasEdges,
        setCanvasNodes,
        setCanvasEdges,
        _isCtxInitialized: true,
        getCanvasNodes,
        getCanvasEdges,
        zoomTransformSuffix,
        stateInitialized,
      }}
    >
      {children}
    </CanvasStateContext.Provider>
  );
};

export const useSweepCanvasState = () => {
  const ctx = useContext(CanvasStateContext);
  if (!ctx._isCtxInitialized) {
    throw new Error('CanvasStateContext not initialized');
  }
  return ctx;
};
